import {ValueObject} from '@s-ui/domain'

export class SearchResultsDealerRequest extends ValueObject {
  /**
   * @param {Object} params
   * @param {Object} params.filters
   * @param {String} params.filters.price
   * @param {Object} params.pagination
   * @param {String} params.pagination.page
   * @param {String} params.pagination.size
   * @param {Object} params.sort
   * @param {String} params.sort.term
   * @param {String} params.sort.order
   */
}
